var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pt-0 ptHeader mainBackVaillant widthFull mb-5 pb-5 " },
    [
      _vm.loadingState ? _c("loading") : _vm._e(),
      _vm._v(" "),
      _vm.registration1
        ? _c("div", { staticClass: "container whiteCont  mb-5" }, [
            _c("div", { staticClass: "row  justify-content-center" }, [
              _c("div", { staticClass: "col-md-12 center " }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-12 text-left mb-4 " }, [
                _vm.proccess == "START"
                  ? _c("h2", { staticClass: "black" }, [
                      _vm.brand == "CHEBONUS"
                        ? _c("b", [_vm._v("Registrazione a CheBonus")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.brand == "HAPPYBONUS"
                        ? _c("b", [_vm._v("Registrazione a HappyBonus")])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.proccess == "START"
                  ? _c(
                      "h5",
                      { staticClass: "black" },
                      [
                        _vm._v(
                          '\n          Inserisci i dati richiesti,  clicca su "Registrati" ed attendi l\'approvazione di\n          '
                        ),
                        _vm.brand == "CHEBONUS"
                          ? [_vm._v(" Vaillant ")]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.brand == "HAPPYBONUS"
                          ? [_vm._v(" Hermann Saunier Duval ")]
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.proccess == "START"
                  ? _c("p", { staticClass: "black" }, [
                      _vm._v(
                        "\n          I campi contrassegnati con * sono obbligatori\n        "
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.proccess == "REG_SUCCESS"
                ? _c(
                    "div",
                    {
                      staticClass:
                        "widthFull center pb-5 mb-5 vaillantCont pt-5"
                    },
                    [
                      _c("h1", { staticClass: "widthFull center mt-3 black" }, [
                        _vm._v("Ci sei quasi! ")
                      ]),
                      _vm._v(" "),
                      !_vm.formed
                        ? _c(
                            "h3",
                            { staticClass: "widthFull center black mt-5 mb-5" },
                            [
                              _vm._v(
                                "\n          La tua richiesta è stata inoltrata per approvazione.\n          "
                              ),
                              _c("br"),
                              _c("br"),
                              _vm._v(
                                "A breve riceverai la conferma della registrazione "
                              ),
                              _c("br"),
                              _vm._v(
                                "via email e potrai accedere alla piattaforma.\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formed
                        ? _c(
                            "h3",
                            { staticClass: "widthFull center black mt-5" },
                            [
                              _vm._v(
                                "\n          TI abbiamo inviato una mail al tuo indirizzo di posta elettronica\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formed
                        ? _c("h3", { staticClass: "widthFull center" }, [
                            _c("b", [
                              _vm._v(
                                "Per confermare la tua registrazione clicca sul link che trovi all’interno."
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formed
                        ? _c(
                            "h4",
                            {
                              staticClass: "widthFull center mt-5 mb-5",
                              staticStyle: { color: "black" }
                            },
                            [
                              _vm._v(
                                "\n          Verifica per favore anche nella cartella Spam o Posta indesiderata\n        "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formed
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary",
                              class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                              attrs: { to: "/login" }
                            },
                            [_vm._v("\n          LOGIN\n        ")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.formed
                        ? _c(
                            "router-link",
                            {
                              staticClass: "btn btn-primary",
                              class: { btnHSDRed: _vm.brand == "HAPPYBONUS" },
                              attrs: { to: "/" }
                            },
                            [_vm._v("\n          HOME\n        ")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.proccess == "START"
              ? _c(
                  "form",
                  {
                    staticClass: "pb-5 pt-4 black vaillantCont",
                    attrs: { id: "registration-form" }
                  },
                  [
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "row justify-content-center" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.azienda,
                                    expression: "azienda"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 128, min: 3 },
                                    expression:
                                      "{required:true, max: 128, min: 3}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("azienda"),
                                  valid: !!_vm.azienda
                                },
                                attrs: {
                                  type: "text",
                                  id: "azienda",
                                  name: "azienda",
                                  "data-vv-as": "Ragione sociale"
                                },
                                domProps: { value: _vm.azienda },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.azienda = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "azienda" }
                                },
                                [_vm._v("Ragione sociale * ")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("azienda")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("azienda")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.partita_iva,
                                    expression: "partita_iva"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      partitaIva: true,
                                      max: 11,
                                      min: 11
                                    },
                                    expression:
                                      "{required:true, partitaIva: true, max: 11, min: 11,}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("partita_iva"),
                                  valid: !!_vm.partita_iva
                                },
                                attrs: {
                                  type: "text",
                                  id: "partita_iva",
                                  name: "partita_iva",
                                  "data-vv-as": "Partita IVA"
                                },
                                domProps: { value: _vm.partita_iva },
                                on: {
                                  blur: _vm.checkIfExistUser,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.partita_iva = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "partita_iva" }
                                },
                                [_vm._v("Partita IVA *")]
                              ),
                              _vm._v(" "),
                              _vm.existPIVA
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "invalid-feedback",
                                      staticStyle: { display: "block" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Partita IVA inserita già presente."
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("partita_iva")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("partita_iva")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.codice_fiscale,
                                    expression: "codice_fiscale"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      codiceFiscale:
                                        _vm.tipo_azienda ==
                                          "Ditta Individuale" ||
                                        _vm.tipo_azienda ==
                                          "Professionista iscritto ad albi",
                                      partitaIva:
                                        _vm.tipo_azienda !=
                                          "Ditta Individuale" &&
                                        _vm.tipo_azienda !=
                                          "Professionista iscritto ad albi",
                                      max:
                                        _vm.tipo_azienda ==
                                          "Ditta Individuale" ||
                                        _vm.tipo_azienda ==
                                          "Professionista iscritto ad albi"
                                          ? 16
                                          : 11,
                                      min:
                                        _vm.tipo_azienda ==
                                          "Ditta Individuale" ||
                                        _vm.tipo_azienda ==
                                          "Professionista iscritto ad albi"
                                          ? 16
                                          : 11
                                    },
                                    expression:
                                      "{required: true, codiceFiscale: tipo_azienda == 'Ditta Individuale' || tipo_azienda == 'Professionista iscritto ad albi', partitaIva: tipo_azienda != 'Ditta Individuale' && tipo_azienda != 'Professionista iscritto ad albi',  max: tipo_azienda == 'Ditta Individuale' || tipo_azienda == 'Professionista iscritto ad albi' ? 16 : 11, min:  tipo_azienda == 'Ditta Individuale' || tipo_azienda == 'Professionista iscritto ad albi' ? 16 : 11}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has(
                                    "codice_fiscale"
                                  ),
                                  valid: !!_vm.codice_fiscale
                                },
                                attrs: {
                                  type: "text",
                                  id: "codice_fiscale",
                                  name: "codice_fiscale",
                                  "data-vv-as": "Codice Fiscale"
                                },
                                domProps: { value: _vm.codice_fiscale },
                                on: {
                                  blur: _vm.checkIfExistUser,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.codice_fiscale = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "codice_fiscale" }
                                },
                                [_vm._v("Codice Fiscale *")]
                              ),
                              _vm._v(" "),
                              _vm.existCF
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "invalid-feedback",
                                      staticStyle: { display: "block" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Codice Fiscale inserito già presente."
                                        )
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("codice_fiscale")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.errors.first("codice_fiscale")
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row justify-content-center" }, [
                        _c(
                          "div",
                          {
                            staticClass: "mb-3 ",
                            class: {
                              "col-md-3":
                                _vm.tipo_azienda != "Ditta Individuale" &&
                                _vm.tipo_azienda !=
                                  "Professionista iscritto ad albi",
                              "col-md-3":
                                _vm.tipo_azienda == "Ditta Individuale" ||
                                _vm.tipo_azienda ==
                                  "Professionista iscritto ad albi"
                            }
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "group custInput",
                                class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.tipo_azienda,
                                        expression: "tipo_azienda"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: { required: true },
                                        expression: "{required:true}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has(
                                        "tipo_azienda"
                                      ),
                                      valid: !!_vm.tipo_azienda
                                    },
                                    attrs: {
                                      autocomplete: "randomy",
                                      id: "tipo_azienda",
                                      name: "tipo_azienda",
                                      "data-vv-as": "Forma Giuridica"
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.tipo_azienda = $event.target
                                          .multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "optgroup",
                                      {
                                        attrs: {
                                          label:
                                            "SOGGETTI CON PERSONALITA’ GIURIDICA"
                                        }
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            key: 111,
                                            attrs: {
                                              value:
                                                "Società in accomandita per azioni"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società in accomandita per azioni\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 112,
                                            attrs: {
                                              value:
                                                "Società a responsabilità limitata"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società a responsabilità limitata\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 113,
                                            attrs: {
                                              value: "Società per azioni"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società per azioni\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 114,
                                            attrs: {
                                              value:
                                                "Società in nome collettivo"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società in nome collettivo\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 115,
                                            attrs: {
                                              value:
                                                "Società in accomandita semplice"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società in accomandita semplice\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 116,
                                            attrs: {
                                              value: "Società cooperative"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Società cooperative\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 117,
                                            attrs: {
                                              value:
                                                "Consorzi con o senza personalità giuridica"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Consorzi con o senza personalità giuridica\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 118,
                                            attrs: {
                                              value: "Associazioni riconosciute"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Associazioni riconosciute\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 119,
                                            attrs: {
                                              value:
                                                "STP Società tra professionisti"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  STP Società tra professionisti\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "optgroup",
                                      { attrs: { label: "PERSONE FISICHE" } },
                                      [
                                        _c(
                                          "option",
                                          {
                                            key: 311,
                                            attrs: {
                                              value: "Ditta Individuale"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Ditta Individuale\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            key: 312,
                                            attrs: {
                                              value:
                                                "Professionista iscritto ad albi"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Professionista iscritto ad albi\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "highlight" }),
                                _vm._v(" "),
                                _c("span", { staticClass: "bar" }),
                                _vm._v(" "),
                                _c(
                                  "label",
                                  {
                                    staticClass: "niceInputLabel",
                                    attrs: { for: "region" }
                                  },
                                  [_vm._v("Forma Giuridica *")]
                                ),
                                _vm._v(" "),
                                _vm.errors.has("tipo_azienda")
                                  ? _c(
                                      "div",
                                      { staticClass: "invalid-feedback" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.errors.first("tipo_azienda")
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.tipo_azienda == "Ditta Individuale" ||
                        _vm.tipo_azienda == "Professionista iscritto ad albi"
                          ? _c("div", { staticClass: "col-md-3 mb-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c(
                                    "select",
                                    {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.reg_forfettario,
                                          expression: "reg_forfettario"
                                        },
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: { required: true },
                                          expression: "{required:true}"
                                        }
                                      ],
                                      staticClass: "form-control",
                                      class: {
                                        "is-invalid": _vm.errors.has(
                                          "reg_forfettario"
                                        ),
                                        valid: !!_vm.reg_forfettario
                                      },
                                      attrs: {
                                        autocomplete: "randomy",
                                        id: "reg_forfettario",
                                        name: "reg_forfettario",
                                        "data-vv-as": "Regime Forfettario"
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$selectedVal = Array.prototype.filter
                                            .call(
                                              $event.target.options,
                                              function(o) {
                                                return o.selected
                                              }
                                            )
                                            .map(function(o) {
                                              var val =
                                                "_value" in o
                                                  ? o._value
                                                  : o.value
                                              return val
                                            })
                                          _vm.reg_forfettario = $event.target
                                            .multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option",
                                        { key: 911, attrs: { value: "si" } },
                                        [
                                          _vm._v(
                                            "\n                  si\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        { key: 912, attrs: { value: "no" } },
                                        [
                                          _vm._v(
                                            "\n                  no\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "region" }
                                    },
                                    [_vm._v("Regime Forfettario *")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("reg_forfettario")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first(
                                                  "reg_forfettario"
                                                )
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 mb-3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.reg_role,
                                      expression: "reg_role"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: { required: true },
                                      expression: "{required:true}"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: {
                                    "is-invalid": _vm.errors.has("reg_role"),
                                    valid: !!_vm.reg_role
                                  },
                                  attrs: {
                                    autocomplete: "randomy",
                                    id: "reg_role",
                                    name: "reg_role",
                                    "data-vv-as":
                                      "Tipologia fornitura ed installazione prodotti"
                                  },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.reg_role = $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      key: 911,
                                      attrs: { value: "Installatore" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Formula installatore ( Flusso MBFACTA e/o General Contractor Agile Energy )\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      key: 912,
                                      attrs: { value: "General Contractor" }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Formula General Contractor ( solo Flusso MBFACTA )\n                "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "region" }
                                },
                                [_vm._v("Formula di installazione prodotti *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("reg_role")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("reg_role")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-md-4",
                          class: {
                            "col-md-3":
                              _vm.tipo_azienda != "Ditta Individuale" &&
                              _vm.tipo_azienda !=
                                "Professionista iscritto ad albi",
                            "col-md-3":
                              _vm.tipo_azienda == "Ditta Individuale" ||
                              _vm.tipo_azienda ==
                                "Professionista iscritto ad albi"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.lastname,
                                    expression: "lastname"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 55, min: 2 },
                                    expression:
                                      "{required:true, max: 55, min: 2}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("lastname"),
                                  valid: !!_vm.lastname
                                },
                                attrs: {
                                  type: "text",
                                  id: "lastname",
                                  name: "lastname",
                                  "data-vv-as": "Cognome"
                                },
                                domProps: { value: _vm.lastname },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.lastname = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "lastname" }
                                },
                                [_vm._v("Cognome *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("lastname")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("lastname")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "col-md-4",
                          class: {
                            "col-md-3":
                              _vm.tipo_azienda != "Ditta Individuale" &&
                              _vm.tipo_azienda !=
                                "Professionista iscritto ad albi",
                            "col-md-3":
                              _vm.tipo_azienda == "Ditta Individuale" ||
                              _vm.tipo_azienda ==
                                "Professionista iscritto ad albi"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.name,
                                    expression: "name"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, max: 55, min: 2 },
                                    expression:
                                      "{required:true, max: 55, min: 2}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("name"),
                                  valid: !!_vm.name
                                },
                                attrs: {
                                  type: "text",
                                  id: "name",
                                  name: "name",
                                  "data-vv-as": "Nome"
                                },
                                domProps: { value: _vm.name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.name = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "name" }
                                },
                                [_vm._v("Nome *")]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("name")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("name")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-4 mb-3 " }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.email,
                                  expression: "email"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    email: true,
                                    temporaryEmail: true,
                                    plusIssueEmail: true,
                                    max: 56
                                  },
                                  expression:
                                    "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                }
                              ],
                              ref: "email",
                              staticClass: "form-control",
                              class: {
                                "is-invalid":
                                  _vm.errors.has("email") || _vm.existEmail,
                                valid: !!_vm.email
                              },
                              attrs: {
                                type: "text",
                                id: "email",
                                name: "email",
                                "data-vv-as": "Email"
                              },
                              domProps: { value: _vm.email },
                              on: {
                                blur: _vm.checkIfExistUser,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.email = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "email" }
                              },
                              [_vm._v("Email* ")]
                            ),
                            _vm._v(" "),
                            _vm.existEmail
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "invalid-feedback",
                                    staticStyle: { display: "block" }
                                  },
                                  [
                                    _c("span", [
                                      _vm._v("Email digitato già presente")
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("email")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("email")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.password,
                                  expression: "password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    passwordCheck: true,
                                    min: 8,
                                    max: 56
                                  },
                                  expression:
                                    "{required:true, passwordCheck: true, min: 8, max: 56}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("password"),
                                valid: !!_vm.password
                              },
                              attrs: {
                                type: "password",
                                id: "password",
                                name: "password",
                                "data-vv-as": "Password"
                              },
                              domProps: { value: _vm.password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.password = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "password" }
                              },
                              [_vm._v("Inserisci una password *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("password")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("password")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.confirm_password,
                                  expression: "confirm_password"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    passwordCheck: true,
                                    min: 8,
                                    max: 56,
                                    confirmed: _vm.password
                                  },
                                  expression:
                                    "{required:true, passwordCheck: true, min: 8, max: 56,confirmed:password}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has(
                                  "confirm_password"
                                ),
                                valid: !!_vm.confirm_password
                              },
                              attrs: {
                                type: "password",
                                id: "confirm_password",
                                name: "confirm_password",
                                "data-vv-as": "Conferma Password"
                              },
                              domProps: { value: _vm.confirm_password },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.confirm_password = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "confirm_password" }
                              },
                              [_vm._v("Conferma la password *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("confirm_password")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.errors.first("confirm_password")
                                      ) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _vm.phone
                              ? _c("span", { staticClass: "custLabel" }, [
                                  _vm._v("+39 ")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.phone,
                                  expression: "phone"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    max: 10,
                                    min: 8,
                                    notZeros: true,
                                    regex: /^[0,3]+/
                                  },
                                  expression:
                                    "{required:true, max: 10, min: 8,notZeros: true,regex: /^[0,3]+/}"
                                }
                              ],
                              staticClass: "form-control cspad",
                              class: {
                                "is-invalid": _vm.errors.has("phone"),
                                valid: !!_vm.phone
                              },
                              attrs: {
                                type: "text",
                                id: "phone",
                                name: "phone",
                                "data-vv-as": "Telefono"
                              },
                              domProps: { value: _vm.phone },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.phone = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "phone" }
                              },
                              [_vm._v("Telefono * ")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("phone")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("phone")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _vm.cellulare
                              ? _c("span", { staticClass: "custLabel" }, [
                                  _vm._v("+39 ")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.cellulare,
                                  expression: "cellulare"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    max: 10,
                                    min: 8,
                                    notZeros: true,
                                    regex: /^[0,3]+/
                                  },
                                  expression:
                                    "{required:true, max: 10, min: 8,notZeros: true,regex: /^[0,3]+/}"
                                }
                              ],
                              staticClass: "form-control cspad",
                              class: {
                                "is-invalid": _vm.errors.has("cellulare"),
                                valid: !!_vm.cellulare
                              },
                              attrs: {
                                type: "text",
                                id: "cellulare",
                                name: "cellulare",
                                "data-vv-as": "Cellulare"
                              },
                              domProps: { value: _vm.cellulare },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.cellulare = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "cellulare" }
                              },
                              [_vm._v("Cellulare * ")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("cellulare")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("cellulare")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.address,
                                  expression: "address"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 128, min: 5 },
                                  expression:
                                    "{required:true, max: 128, min: 5}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("address"),
                                valid: !!_vm.address
                              },
                              attrs: {
                                type: "text",
                                autocomplete: "randomr",
                                id: "address",
                                name: "address",
                                "data-vv-as": "Indirizzo"
                              },
                              domProps: { value: _vm.address },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.address = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "address" }
                              },
                              [_vm._v("Indirizzo (via, piazza, etc. ) *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("address")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("address")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-2 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.civic,
                                  expression: "civic"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true, max: 15 },
                                  expression: "{required:true, max: 15}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("civic"),
                                valid: !!_vm.civic
                              },
                              attrs: {
                                type: "text",
                                autocomplete: "randomt",
                                id: "civic",
                                name: "civic",
                                "data-vv-as": "N. Civico"
                              },
                              domProps: { value: _vm.civic },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.civic = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "civic" }
                              },
                              [_vm._v("N. Civico *")]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("civic")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("civic")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.region,
                                    expression: "region"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{required:true}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("region"),
                                  valid: !!_vm.region
                                },
                                attrs: {
                                  autocomplete: "randomy",
                                  id: "region",
                                  name: "region",
                                  "data-vv-as": "Regione"
                                },
                                on: {
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.region = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.regions, function(region) {
                                return _c(
                                  "option",
                                  {
                                    key: region.id_regione,
                                    domProps: {
                                      value: {
                                        id: region.id_regione,
                                        text: region.regione
                                      },
                                      selected:
                                        region.id_regione == _vm.shipData.region
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(region.regione) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "region" }
                              },
                              [_vm._v("Regione *")]
                            ),
                            _vm._v(" "),
                            _vm.regionsState
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "loadSpinner",
                                      attrs: {
                                        id: "loadregion",
                                        icon: "spinner",
                                        size: "1x",
                                        pulse: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("region")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("region")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.province,
                                    expression: "province"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{required:true}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("province"),
                                  valid: !!_vm.province
                                },
                                attrs: {
                                  autocomplete: "randomy",
                                  id: "province",
                                  name: "province",
                                  "data-vv-as": "Provincia"
                                },
                                on: {
                                  click: _vm.checkRegion,
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.province = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.provincies, function(province) {
                                return _c(
                                  "option",
                                  {
                                    key: province.sigla,
                                    domProps: {
                                      value: province.sigla,
                                      selected:
                                        province.sigla == _vm.shipData.province
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(province.sigla) +
                                        " - " +
                                        _vm._s(province.provincia) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "province" }
                              },
                              [
                                _vm._v("Provincia *"),
                                _vm.provinceError
                                  ? _c("span", { staticClass: "formError" }, [
                                      _vm._v("Prima scegli Regione")
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.provinciesState
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "loadSpinner",
                                      attrs: {
                                        id: "loadProvince",
                                        icon: "spinner",
                                        size: "1x",
                                        pulse: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("province")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("province")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.city,
                                    expression: "city"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{required:true}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("city"),
                                  valid: !!_vm.city
                                },
                                attrs: {
                                  autocomplete: "randomu",
                                  id: "city",
                                  name: "city",
                                  "data-vv-as": "Località",
                                  disabled: _vm.citiesState
                                },
                                on: {
                                  click: _vm.checkProvince,
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.city = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.cities, function(city) {
                                return _c(
                                  "option",
                                  {
                                    key: city.comune,
                                    domProps: {
                                      value: {
                                        cityistat: city.istat,
                                        city: city.comune
                                      },
                                      selected: city.comune == _vm.shipData.city
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(city.comune) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "city" }
                              },
                              [
                                _vm._v("Località *"),
                                _vm.cityError
                                  ? _c("span", { staticClass: "formError" }, [
                                      _vm._v("Prima scegli Provincia")
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.citiesState
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "loadSpinner",
                                      attrs: {
                                        id: "loadCity",
                                        icon: "spinner",
                                        size: "1x",
                                        pulse: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("city")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("city")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-3 mb-3" }, [
                        _c(
                          "div",
                          {
                            staticClass: "group custInput",
                            class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.zip,
                                    expression: "zip"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{required:true}"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("zip"),
                                  valid: !!_vm.zip
                                },
                                attrs: {
                                  autocomplete: "randomi",
                                  id: "zip",
                                  name: "zip",
                                  "data-vv-as": "CAP",
                                  disabled: _vm.zipsState
                                },
                                on: {
                                  click: _vm.checkZip,
                                  change: function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.zip = $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  }
                                }
                              },
                              _vm._l(_vm.zips, function(zip) {
                                return _c(
                                  "option",
                                  {
                                    key: zip.cap,
                                    domProps: {
                                      value: zip.cap,
                                      selected: zip.cap == _vm.shipData.zip
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(zip.cap) +
                                        "\n              "
                                    )
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel",
                                attrs: { for: "zip" }
                              },
                              [
                                _vm._v("CAP *"),
                                _vm.zipError
                                  ? _c("span", { staticClass: "formError" }, [
                                      _vm._v("Prima scegli Località")
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.zipsState
                              ? _c(
                                  "div",
                                  [
                                    _c("font-awesome-icon", {
                                      staticClass: "loadSpinner",
                                      attrs: {
                                        id: "loadZips",
                                        icon: "spinner",
                                        size: "1x",
                                        pulse: ""
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.errors.has("zip")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("zip")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "row justify-content-center divider"
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row justify-content-center pt-3" },
                      [
                        _c("div", { staticClass: "col-md-12 mb-3 center" }, [
                          _c("h5", { staticClass: "black center" }, [
                            _vm._v(
                              "Inserisci PEC ( Posta Elettronica Certificata ) e codice SDI ( Codice Destinatario per fatturazione elettronica )"
                            )
                          ]),
                          _vm._v(" "),
                          3 == 4
                            ? _c("img", {
                                staticClass: "ptImage mr-3",
                                attrs: {
                                  src: require("../../assets/images/Poste.jpg")
                                }
                              })
                            : _vm._e(),
                          3 == 4
                            ? _c("small", [
                                _vm._v(
                                  "Attenzione! Per usufruire del servizio è necessario inserire "
                                ),
                                _c("b", [
                                  _vm._v(
                                    "iban del conto corrente affari di poste italiane"
                                  )
                                ]),
                                _vm._v(". ")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          3 == 4
                            ? _c("small", [
                                _vm._v(
                                  " ( può essere inserito anche successivamente ) "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        3 == 4
                          ? _c("div", { staticClass: "col-md-5 mb-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.iban,
                                        expression: "iban"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          ibanControl: true,
                                          ibanItalian: true,
                                          ibanPoste: true,
                                          max: 27,
                                          min: 27
                                        },
                                        expression:
                                          "{ ibanControl: true, ibanItalian: true, ibanPoste: true,  max: 27, min: 27}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has("iban"),
                                      valid: !!_vm.iban
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomr",
                                      id: "iban",
                                      name: "iban",
                                      "data-vv-as": "IBAN"
                                    },
                                    domProps: { value: _vm.iban },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.iban = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "iban" }
                                    },
                                    [_vm._v("IBAN Poste Italiane")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("iban")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(_vm.errors.first("iban")) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        3 == 4
                          ? _c("div", { staticClass: "col-md-7 mb-3" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "group custInput",
                                  class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                                },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.ibanNome,
                                        expression: "ibanNome"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: {
                                          required: _vm.iban != "",
                                          max: 128,
                                          min: 5
                                        },
                                        expression:
                                          "{required:iban != '', max: 128, min: 5}"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    class: {
                                      "is-invalid": _vm.errors.has("ibanNome"),
                                      valid: !!_vm.ibanNome
                                    },
                                    attrs: {
                                      type: "text",
                                      autocomplete: "randomr",
                                      id: "ibanNome",
                                      name: "ibanNome",
                                      "data-vv-as": "Nome intestatario"
                                    },
                                    domProps: { value: _vm.ibanNome },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.ibanNome = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "highlight" }),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "bar" }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "niceInputLabel",
                                      attrs: { for: "ibanNome" }
                                    },
                                    [_vm._v("Intestazione conto")]
                                  ),
                                  _vm._v(" "),
                                  _vm.errors.has("ibanNome")
                                    ? _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.errors.first("ibanNome")
                                              ) +
                                              "\n            "
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 mb-3 " }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.emailPEC,
                                    expression: "emailPEC"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {
                                      required: true,
                                      email: true,
                                      temporaryEmail: true,
                                      plusIssueEmail: true,
                                      max: 56
                                    },
                                    expression:
                                      "{required:true,email: true, temporaryEmail:true, plusIssueEmail: true, max: 56}"
                                  }
                                ],
                                ref: "emailPEC",
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("emailPEC"),
                                  valid: !!_vm.emailPEC
                                },
                                attrs: {
                                  type: "text",
                                  id: "emailPEC",
                                  name: "emailPEC",
                                  "data-vv-as": "email PEC"
                                },
                                domProps: { value: _vm.emailPEC },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.emailPEC = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "email" }
                                },
                                [_vm._v("Email PEC* ")]
                              ),
                              _vm._v(" "),
                              _vm.existEmail
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "invalid-feedback",
                                      staticStyle: { display: "block" }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v("Email digitato già presente")
                                      ])
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.errors.has("emailPEC")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("emailPEC")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6 mb-3 " }, [
                          _c(
                            "div",
                            {
                              staticClass: "group custInput",
                              class: { inputHSD: _vm.brand == "HAPPYBONUS" }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.sdiCode,
                                    expression: "sdiCode"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true, min: 7, max: 7 },
                                    expression:
                                      "{required:true, min: 7, max: 7}"
                                  }
                                ],
                                ref: "sdiCode",
                                staticClass: "form-control",
                                class: {
                                  "is-invalid": _vm.errors.has("sdiCode"),
                                  valid: !!_vm.sdiCode
                                },
                                attrs: {
                                  type: "text",
                                  id: "sdiCode",
                                  name: "sdiCode",
                                  "data-vv-as": "CODICE SDI"
                                },
                                domProps: { value: _vm.sdiCode },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.sdiCode = $event.target.value
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "highlight" }),
                              _vm._v(" "),
                              _c("span", { staticClass: "bar" }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "niceInputLabel",
                                  attrs: { for: "sdiCode" }
                                },
                                [
                                  _vm._v(
                                    "CODICE SDI fatturazione elettronica * "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("sdiCode")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.errors.first("sdiCode")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mb-4" }, [
                      _c("div", { staticClass: "col-md-2 mb-3 center" }, [
                        _vm.invoiceFrontBucket
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.invoiceFrontBucket,
                                  target: "_blank"
                                }
                              },
                              [
                                _vm.invoiceFrontBucket.substring(
                                  _vm.invoiceFrontBucket.lastIndexOf(".") + 1,
                                  _vm.invoiceFrontBucket.length
                                ) == "pdf"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "center widthFull pdfLink",
                                        attrs: {
                                          href: _vm.invoiceFrontBucket,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v("APRI "),
                                        _c("br"),
                                        _vm._v(" PDF")
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-4 mb-3 " }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "front-image",
                            class: {
                              "front-imageHSD": _vm.brand == "HAPPYBONUS"
                            }
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: false,
                                    size: 10240,
                                    ext: ["jpeg", "jpg", "png"],
                                    mimes: [
                                      "image/jpeg",
                                      "image/jpg",
                                      "image/png"
                                    ]
                                  },
                                  expression:
                                    "{required:false,size: 10240, ext: ['jpeg','jpg','png'], mimes: ['image/jpeg', 'image/jpg', 'image/png']}"
                                }
                              ],
                              ref: "fileInput",
                              staticClass: "fileInput",
                              class: {
                                "is-invalid": _vm.errors.has("invoiceFront"),
                                valid: !!_vm.invoiceFront,
                                helper: !!_vm.invoiceFrontBucket
                              },
                              attrs: {
                                type: "file",
                                name: "invoiceFront",
                                id: "invoiceFront",
                                "data-vv-as": "Logo"
                              },
                              on: { change: _vm.uploadFile }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "highlight" }),
                            _vm._v(" "),
                            _c("span", { staticClass: "bar" }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "niceInputLabel labelFileInput",
                                attrs: { for: "invoiceFront" }
                              },
                              [
                                !_vm.invoiceFrontName
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "smallText center white",
                                        style: {
                                          backgroundImage:
                                            "url(" +
                                            _vm.invoiceFrontBucket +
                                            ")"
                                        }
                                      },
                                      [
                                        !_vm.invoiceFrontName
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "smallText center white mt-3 mb-0 pb-0"
                                              },
                                              [
                                                _vm._v(
                                                  "Scegli il Contratto quadro*"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  : _c("span", {
                                      staticClass: "smallText center white",
                                      style: {
                                        backgroundImage:
                                          "url(" + _vm.invoiceFrontBucket + ")"
                                      }
                                    })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("invoiceFront")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.errors.first("invoiceFront")) +
                                      "\n            "
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.uploadFrontPercentage
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "progress",
                                    attrs: { id: "progFront" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "progress-bar ",
                                        style: {
                                          width: _vm.uploadFrontPercentage + "%"
                                        },
                                        attrs: {
                                          id: "progress-bar-front",
                                          role: "progressbar",
                                          "aria-valuenow": "50",
                                          "aria-valuemin": "0",
                                          "aria-valuemax": "100"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(_vm.uploadFrontPercentage) +
                                            " %\n              "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.invoiceFrontName
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "smallText center white mt-3 mb-0 pb-0 fileNameText"
                                  },
                                  [_vm._v(_vm._s(_vm.invoiceFrontName))]
                                )
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(1)
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row " }, [
                      _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("div", { staticClass: "p-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.privacy,
                                  expression: "privacy"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required: true}"
                                }
                              ],
                              staticClass: "form-check-input",
                              class: {
                                "is-invalid": _vm.errors.has("privacy")
                              },
                              attrs: {
                                type: "checkbox",
                                id: "privacy",
                                name: "privacy",
                                "data-vv-as": "Termini di utilizzo"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.privacy)
                                  ? _vm._i(_vm.privacy, null) > -1
                                  : _vm.privacy
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.privacy,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.privacy = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.privacy = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.privacy = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label textStable",
                                attrs: { for: "privacy" }
                              },
                              [
                                _vm._v(
                                  "\n                Effettuando la registrazione ed utilizzando i servizi forniti da questo Sito accetto i presenti\n                "
                                ),
                                _vm.brand == "CHEBONUS"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "green",
                                        class: {
                                          redHSD: _vm.brand == "HAPPYBONUS"
                                        },
                                        attrs: {
                                          href:
                                            "https://storage.googleapis.com/chebonus/Conditions.pdf?v=2",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Termini di utilizzo\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.brand == "HAPPYBONUS"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "green",
                                        class: {
                                          redHSD: _vm.brand == "HAPPYBONUS"
                                        },
                                        attrs: {
                                          href:
                                            "https://storage.googleapis.com/happybonus/Conditions.pdf?v=2",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Termini di utilizzo\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("privacy")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("privacy")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row " }, [
                      _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("div", { staticClass: "p-3" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.privacy1,
                                  expression: "privacy1"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: { required: true },
                                  expression: "{required: true}"
                                }
                              ],
                              staticClass: "form-check-input",
                              class: {
                                "is-invalid": _vm.errors.has("privacy1")
                              },
                              attrs: {
                                type: "checkbox",
                                id: "privacy1",
                                name: "privacy1",
                                "data-vv-as": "Informativa privacy"
                              },
                              domProps: {
                                checked: Array.isArray(_vm.privacy1)
                                  ? _vm._i(_vm.privacy1, null) > -1
                                  : _vm.privacy1
                              },
                              on: {
                                change: function($event) {
                                  var $$a = _vm.privacy1,
                                    $$el = $event.target,
                                    $$c = $$el.checked ? true : false
                                  if (Array.isArray($$a)) {
                                    var $$v = null,
                                      $$i = _vm._i($$a, $$v)
                                    if ($$el.checked) {
                                      $$i < 0 &&
                                        (_vm.privacy1 = $$a.concat([$$v]))
                                    } else {
                                      $$i > -1 &&
                                        (_vm.privacy1 = $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1)))
                                    }
                                  } else {
                                    _vm.privacy1 = $$c
                                  }
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "form-check-label textStable",
                                attrs: { for: "privacy1" }
                              },
                              [
                                _vm._v(
                                  "\n                Dichiaro di aver letto, compreso ed accettato\n                "
                                ),
                                _vm.brand == "CHEBONUS"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "green",
                                        class: {
                                          redHSD: _vm.brand == "HAPPYBONUS"
                                        },
                                        attrs: {
                                          href:
                                            "https://storage.googleapis.com/chebonus/Privacy.pdf?v=2",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  l’Informativa privacy\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.brand == "HAPPYBONUS"
                                  ? _c(
                                      "a",
                                      {
                                        staticClass: "green",
                                        class: {
                                          redHSD: _vm.brand == "HAPPYBONUS"
                                        },
                                        attrs: {
                                          href:
                                            "https://storage.googleapis.com/happybonus/Privacy.pdf?v=2",
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  l’Informativa privacy\n                "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _vm.errors.has("privacy1")
                              ? _c("div", { staticClass: "invalid-feedback" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.errors.first("privacy1")) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: 1 == 2,
                            expression: "1==2"
                          }
                        ],
                        staticClass: "row "
                      },
                      [
                        _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                          _c("div", { staticClass: "form-check" }, [
                            _c("div", { staticClass: "p-3" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.privacy2,
                                    expression: "privacy2"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {},
                                    expression: "{}"
                                  }
                                ],
                                staticClass: "form-check-input",
                                class: {
                                  "is-invalid": _vm.errors.has("privacy2")
                                },
                                attrs: {
                                  type: "checkbox",
                                  id: "privacy2",
                                  name: "privacy2",
                                  "data-vv-as": "Informativa privacy2"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.privacy2)
                                    ? _vm._i(_vm.privacy2, null) > -1
                                    : _vm.privacy2
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.privacy2,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.privacy2 = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.privacy2 = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.privacy2 = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label textStable",
                                  attrs: { for: "privacy2" }
                                },
                                [
                                  _vm._v(
                                    "\n                Dichiaro di aver letto e compreso\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "green",
                                      class: {
                                        redHSD: _vm.brand == "HAPPYBONUS"
                                      },
                                      attrs: {
                                        href: "privacy.pdf",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  l’Informativa privacy\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                resa dal Titolare del trattamento ai sensi dell’art. 13 del GDPR*\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("privacy2")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("privacy2")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: 1 == 2,
                            expression: "1==2"
                          }
                        ],
                        staticClass: "row "
                      },
                      [
                        _c("div", { staticClass: "col-md-12 mb-3 pr-4" }, [
                          _c("div", { staticClass: "form-check" }, [
                            _c("div", { staticClass: "p-3" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.privacy3,
                                    expression: "privacy3"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: {},
                                    expression: "{}"
                                  }
                                ],
                                staticClass: "form-check-input",
                                class: {
                                  "is-invalid": _vm.errors.has("privacy3")
                                },
                                attrs: {
                                  type: "checkbox",
                                  id: "privacy3",
                                  name: "privacy3",
                                  "data-vv-as": "Informativa privacy3"
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.privacy3)
                                    ? _vm._i(_vm.privacy3, null) > -1
                                    : _vm.privacy3
                                },
                                on: {
                                  change: function($event) {
                                    var $$a = _vm.privacy3,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.privacy3 = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.privacy3 = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.privacy3 = $$c
                                    }
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label textStable",
                                  attrs: { for: "privacy3" }
                                },
                                [
                                  _vm._v(
                                    "\n                Dichiaro di aver letto e compreso\n                "
                                  ),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "green",
                                      class: {
                                        redHSD: _vm.brand == "HAPPYBONUS"
                                      },
                                      attrs: {
                                        href: "privacy.pdf",
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  l’Informativa privacy\n                "
                                      )
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                resa dal Titolare del trattamento ai sensi dell’art. 13 del GDPR*\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _vm.errors.has("privacy3")
                                ? _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(_vm.errors.first("privacy3")) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "row justify-content-center" }, [
                      _c(
                        "div",
                        { staticClass: "col-md-12 center mb-0  mb-1" },
                        [
                          !_vm.isAuthenticated
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn btn-lg btn-primary",
                                  class: {
                                    btnHSDRed: _vm.brand == "HAPPYBONUS"
                                  },
                                  attrs: { type: "button" },
                                  on: { click: _vm.registration }
                                },
                                [_vm._v("\n            Registrati\n          ")]
                              )
                            : _vm._e()
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e()
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "center" }, [
      _vm._v("Logo Azienda "),
      _c("small", [_vm._v("(formato: jpg, png)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mb-3 " }, [
      _c("h5", { staticClass: "text-left pt-4" }, [
        _vm._v("\n            Carica il logo della tua Azienda\n          ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n            Il logo non è obbligatorio. Se lo carichi, potrai personalizzare i tuoi Preventivi con il logo della tua azienda.\n          "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03a5036f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03a5036f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addClient/index.vue
// module id = null
// module chunks = 